import { type FrameValue, animated } from '@react-spring/web'
import cx from 'classnames'
import { useCallback } from 'react'

import { type Step } from '../../lib/step-definition'

import ChevronIcon from '../utility/chevron-icon'

interface ConfigurationStepPreviewProps {
  step: Step
  number: number
  title: string
  value?: string
  error?: string
  placeholder?: string
  onClick: (step: Step) => void
  opacity?: number | FrameValue<number>
  className?: string
  valueClassName?: string
}

export type StepPreviewProps = Pick<
  ConfigurationStepPreviewProps,
  'number' | 'onClick'
>

const ConfigurationStepPreview = ({
  step,
  title,
  value,
  error,
  placeholder,
  opacity = 1,
  number,
  onClick,
  className,
  valueClassName,
}: ConfigurationStepPreviewProps) => {
  const handleClick = useCallback(() => {
    onClick(step)
  }, [onClick, step])

  return (
    <animated.div
      onClick={handleClick}
      className={cx(
        'flex items-center h-[78px] py-5 pr-6 pl-4 select-none hover:cursor-pointer border-b border-gray-300',
        className,
      )}
      style={{
        opacity,
      }}
    >
      <div className="flex items-center space-x-2">
        <div className="grow-0 shrink-0 flex justify-center content-center items-center w-[35px] h-[35px] border-2 border-black rounded-full font-medium text-center">
          {number}
        </div>

        <div className="flex flex-col justify-center h-full space-y-1">
          <span>{title}</span>

          {error && <span className="text-error-bg">{error}</span>}

          {!error && value && <span className={valueClassName}>{value}</span>}

          {!error && !value && placeholder && (
            <span className="italic text-gray-500">{placeholder}</span>
          )}
        </div>
      </div>

      <ChevronIcon
        direction="right"
        className="flex-none inline-block h-[10px] ml-auto"
      />
    </animated.div>
  )
}

export default ConfigurationStepPreview
